<a class="skip-link" href="#main-content" (click)="onSkipLinkActivated($event)">
  Skip to the main content
</a>

<header class="band">
  <div class="band-row">
    <a routerLink="/apps" class="brand">
      <app-octo-mark />
      <span class="wordmark">Octometer</span>
    </a>

    @if (!isSigninRoute()) {
      <app-main-nav />
    }
  </div>

  @if (!isSigninRoute()) {
    @if (me.email(); as email) {
      <div class="account-menu" role="group" aria-label="Account">
        <span class="account-email">{{ email }}</span>
        <button
          type="button"
          class="btn account-button"
          [attr.aria-expanded]="accountEmailRevealed()"
          (click)="onAccountButtonClick()"
        >
          Account
        </button>
        @if (accountEmailRevealed()) {
          <span class="account-email-popup">{{ email }}</span>
        }
        <button type="button" class="btn" (click)="onSignOutClick()">Sign out</button>
      </div>
    }
  }
</header>

<app-banner [apiError]="monitorApiError()" />

@if (!isSigninRoute()) {
  <app-breadcrumb-nav [items]="breadcrumbItems()" />
}

<main id="main-content" tabindex="-1">
  @if (!appReady()) {
    <div class="first-load-row">
      <app-octo-mark [size]="48" />
      <p class="first-load">Octometer is loading…</p>
    </div>
  }

  <router-outlet (activate)="onOutletActivated()" />
</main>

<div role="status" class="visually-hidden">{{ announcer.message() }}</div>
